import React, { useEffect, useState } from "react";
import SectionOne from "../../components/home/SectionOne";
import SectionTwo from "../../components/home/SectionTwo";
import SectionThree from "../../components/home/SectionThree";
import SectionFour from "../../components/home/SectionFour";
import SectionFive from "../../components/home/SectionFive";
import SectionSix from "../../components/home/SectionSix";
import Footer from "../../components/footer/Footer";
import SectionThreeMobile from "../../components/home/SectionThreeMobile";
import Meta from "../../components/Meta";

function HomePage() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
     <Meta 
        title="Home Buying, Apartments, Mortgages & Home Values" 
        description="The leading home buying marketplace. Search millions of for-sale listings, compare home values, and connect with local professionals."
      />
      <SectionOne />
      <SectionTwo />
      {isMobile ? <SectionThreeMobile></SectionThreeMobile> : <SectionThree />}

      <SectionFour />
      <SectionFive />
      <SectionSix />
      <Footer />
    </>
  );
}

export default HomePage;
